module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9QE8uY/tc-custom/9781446370971.jpg?1705539587095",
      "alt": "This image is the cover for the book Craft It with Perler Beads"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Craft It with Perler Beads\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A collection of twenty-five easy-to-follow patterns you can use to turn Perler beads into a wide array of accessories and home goods.")]), _c('br'), _c('br'), _vm._v("A new wave of crafters are turning Perler beads on their head and showing that far from being just novelties for kids, these colorful plastic beads that fuse together when ironed can be used to make stunning sophisticated gifts and accessories."), _c('br'), _c('br'), _vm._v("In this fun collection of genuinely easy makes, you will find over twenty-five easy patterns for a wide range of items—from jewelry such as necklaces, earrings, bracelets, and rings, to home décor items such as coasters, a photo frame, a garland, a clock, and even a lampshade that will have you seeing Perler beads in a whole new light!"), _c('br'), _c('br'), _vm._v("Each project has a full-color chart plus easy-to-follow instructions to guide you through the process from start to finish.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Prudence Rogers\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    A David & Charles Book © F&W Media International, Ltd 2014\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0